import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../layouts/car/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_da1b5468 from 'nuxt_plugin_plugin_da1b5468' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_sentryserver_69ef4284 from 'nuxt_plugin_sentryserver_69ef4284' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_654eed36 from 'nuxt_plugin_sentryclient_654eed36' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_nuxtuseragent_7733997a from 'nuxt_plugin_nuxtuseragent_7733997a' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_router_741971f5 from 'nuxt_plugin_router_741971f5' // Source: ./router.js (mode: 'all')
import nuxt_plugin_vuei18n_9dc1c90a from 'nuxt_plugin_vuei18n_9dc1c90a' // Source: ../../plugins/vue-i18n (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../../plugins/axios (mode: 'all')
import nuxt_plugin_requestcontainercreatorplugin_4e815618 from 'nuxt_plugin_requestcontainercreatorplugin_4e815618' // Source: ../../plugins/dependency-container/request-container-creator-plugin (mode: 'all')
import nuxt_plugin_setloggeruser_031a26c7 from 'nuxt_plugin_setloggeruser_031a26c7' // Source: ../../plugins/set-logger-user (mode: 'client')
import nuxt_plugin_globaldependencycreator_fa63c944 from 'nuxt_plugin_globaldependencycreator_fa63c944' // Source: ../../plugins/global-dependency-creator (mode: 'all')
import nuxt_plugin_vueportal_158772ee from 'nuxt_plugin_vueportal_158772ee' // Source: ../../plugins/vue-portal (mode: 'all')
import nuxt_plugin_error_34fb1f5c from 'nuxt_plugin_error_34fb1f5c' // Source: ../../plugins/error (mode: 'all')
import nuxt_plugin_directives_d0867c0c from 'nuxt_plugin_directives_d0867c0c' // Source: ../../plugins/directives (mode: 'all')
import nuxt_plugin_serverinit_ddc0afb8 from 'nuxt_plugin_serverinit_ddc0afb8' // Source: ../../plugins/server-init (mode: 'server')
import nuxt_plugin_inmobi_5d3751f8 from 'nuxt_plugin_inmobi_5d3751f8' // Source: ../../plugins/inmobi (mode: 'client')
import nuxt_plugin_googlepublishertag_3fed342b from 'nuxt_plugin_googlepublishertag_3fed342b' // Source: ../../plugins/google-publisher-tag (mode: 'client')
import nuxt_plugin_googleanalytics_4722cf30 from 'nuxt_plugin_googleanalytics_4722cf30' // Source: ../../plugins/google-analytics (mode: 'client')
import nuxt_plugin_flash_34e4e38c from 'nuxt_plugin_flash_34e4e38c' // Source: ../../plugins/flash (mode: 'client')
import nuxt_plugin_floatingvue_393b2496 from 'nuxt_plugin_floatingvue_393b2496' // Source: ../../plugins/floating-vue (mode: 'client')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../../plugins/global-components (mode: 'all')
import nuxt_plugin_globaldirectives_418f5490 from 'nuxt_plugin_globaldirectives_418f5490' // Source: ../../plugins/global-directives (mode: 'client')
import nuxt_plugin_webvitals_77846a76 from 'nuxt_plugin_webvitals_77846a76' // Source: ../../plugins/web-vitals (mode: 'client')
import nuxt_plugin_clarity_19afd3de from 'nuxt_plugin_clarity_19afd3de' // Source: ../../plugins/clarity (mode: 'client')
import nuxt_plugin_static_3a780d38 from 'nuxt_plugin_static_3a780d38' // Source: ../../plugins/static (mode: 'all')
import nuxt_plugin_scrolldepth_16b55b8e from 'nuxt_plugin_scrolldepth_16b55b8e' // Source: ../../plugins/scroll-depth (mode: 'client')
import nuxt_plugin_meta_c6659844 from 'nuxt_plugin_meta_c6659844' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"el","itemtype":"https:\u002F\u002Fschema.org\u002FWebPage","itemscope":""},"titleTemplate":"Car.gr - %s","title":"Μεταχειρισμένα αυτοκίνητα","meta":[{"charset":"utf-8"},{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=utf-8"},{"hid":"description","name":"description","content":"Η μεγαλύτερη αγορά για μεταχειρισμένα αυτοκίνητα και ανταλλακτικά στην Ελλάδα."},{"name":"viewport","hid":"viewport","content":"width=device-width, initial-scale=1"},{"name":"msapplication-TileColor","content":"#004e95"},{"name":"msapplication-TileImage","content":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fms-icon-144x144.png"},{"name":"theme-color","content":"#004e95"},{"name":"msapplication-config","content":"\u002F\u002Fstatic.car.gr\u002Fstatic\u002Ffavicon\u002Fbrowserconfig.xml?v=2"},{"name":"application-name","content":"Car.gr"},{"name":"format-detection","content":"telephone=no"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Fog\u002Fcar.jpg"},{"name":"google-site-verification","content":"M73jpsN4jDytqHK_rJCC3TlnpiUD0vm7PmflMnDiRzQ"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fstatic-cz.car.gr","crossorigin":""},{"rel":"preconnect","href":"https:\u002F\u002Fstatic.car.gr","crossorigin":""},{"rel":"preconnect","href":"https:\u002F\u002Fp.typekit.net","crossorigin":""},{"rel":"preconnect","href":"https:\u002F\u002Fuse.typekit.net","crossorigin":""},{"rel":"preload","href":"https:\u002F\u002Fsecurepubads.g.doubleclick.net\u002Ftag\u002Fjs\u002Fgpt.js","as":"script"},{"rel":"preload","href":"https:\u002F\u002Fuse.typekit.net\u002Fhuy0zmt.css","as":"style"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fhuy0zmt.css"},{"rel":"shortcut icon","type":"image\u002Fx-icon","id":"favicon","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"512x512","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Ffavicon-512x512.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fandroid-icon-192x192.png"},{"rel":"manifest","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fmanifest.json"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-180x180.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-60x60.png"},{"rel":"apple-touch-icon-precomposed","sizes":"57x57","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-touch-icon-57x57-precomposed.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-57x57.png"},{"rel":"apple-icon-precomposed","sizes":"180x180","href":"https:\u002F\u002Fstatic-cz.car.gr\u002Fnuxt-static\u002Fimg\u002Ffavicon\u002Fapple-icon-precomposed.png"}],"script":[{"src":"https:\u002F\u002Fsecurepubads.g.doubleclick.net\u002Ftag\u002Fjs\u002Fgpt.js","async":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-71C4JCCCJZ","async":true},{"type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"Organization","url":"https:\u002F\u002Fcar.gr","logo":"https:\u002F\u002Fwww.car.gr\u002Fstatic\u002Flogo-square.png"}},{"type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"WebSite","url":"https:\u002F\u002Fcar.gr","logo":"https:\u002F\u002Fwww.car.gr\u002Fstatic\u002Flogo-square.png","potentialAction":{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https:\u002F\u002Fwww.car.gr\u002Fcars\u002F?q={search_term_string}&from-search-engine=1"},"query-input":"required name=search_term_string"}}}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_da1b5468 === 'function') {
    await nuxt_plugin_plugin_da1b5468(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_69ef4284 === 'function') {
    await nuxt_plugin_sentryserver_69ef4284(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_654eed36 === 'function') {
    await nuxt_plugin_sentryclient_654eed36(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_7733997a === 'function') {
    await nuxt_plugin_nuxtuseragent_7733997a(app.context, inject)
  }

  if (typeof nuxt_plugin_router_741971f5 === 'function') {
    await nuxt_plugin_router_741971f5(app.context, inject)
  }

  if (typeof nuxt_plugin_vuei18n_9dc1c90a === 'function') {
    await nuxt_plugin_vuei18n_9dc1c90a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_requestcontainercreatorplugin_4e815618 === 'function') {
    await nuxt_plugin_requestcontainercreatorplugin_4e815618(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setloggeruser_031a26c7 === 'function') {
    await nuxt_plugin_setloggeruser_031a26c7(app.context, inject)
  }

  if (typeof nuxt_plugin_globaldependencycreator_fa63c944 === 'function') {
    await nuxt_plugin_globaldependencycreator_fa63c944(app.context, inject)
  }

  if (typeof nuxt_plugin_vueportal_158772ee === 'function') {
    await nuxt_plugin_vueportal_158772ee(app.context, inject)
  }

  if (typeof nuxt_plugin_error_34fb1f5c === 'function') {
    await nuxt_plugin_error_34fb1f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_d0867c0c === 'function') {
    await nuxt_plugin_directives_d0867c0c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_serverinit_ddc0afb8 === 'function') {
    await nuxt_plugin_serverinit_ddc0afb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_inmobi_5d3751f8 === 'function') {
    await nuxt_plugin_inmobi_5d3751f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlepublishertag_3fed342b === 'function') {
    await nuxt_plugin_googlepublishertag_3fed342b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_4722cf30 === 'function') {
    await nuxt_plugin_googleanalytics_4722cf30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flash_34e4e38c === 'function') {
    await nuxt_plugin_flash_34e4e38c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_floatingvue_393b2496 === 'function') {
    await nuxt_plugin_floatingvue_393b2496(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globaldirectives_418f5490 === 'function') {
    await nuxt_plugin_globaldirectives_418f5490(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webvitals_77846a76 === 'function') {
    await nuxt_plugin_webvitals_77846a76(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clarity_19afd3de === 'function') {
    await nuxt_plugin_clarity_19afd3de(app.context, inject)
  }

  if (typeof nuxt_plugin_static_3a780d38 === 'function') {
    await nuxt_plugin_static_3a780d38(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrolldepth_16b55b8e === 'function') {
    await nuxt_plugin_scrolldepth_16b55b8e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_c6659844 === 'function') {
    await nuxt_plugin_meta_c6659844(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
